import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles({
  root: {},
  agencyField: {
    // Fill the parent container (agencyWrapper on desktop, headerAgencyRow
    // on mobile) up to 400px. Keeping the cap here lets the layout decide
    // the effective width — desktop shrinks the wrapper on narrow widths
    // (<1200px) so the selector never exceeds the sibling search field.
    width: "100%",
    maxWidth: 400,
    height: 40,
    "& .MuiOutlinedInput-root": {
      height: 40,
      minHeight: 40,
    },
  },
});
